import { MdOutlineCalendarMonth } from 'react-icons/md';
import { BsReverseListColumnsReverse } from 'react-icons/bs';
import { RenderTiles } from '../../../components/common';
import ChildHeader from '../../../components/ui/ChildHeader';

const tiles = [
  {
    sNo: 1,
    link: '/common/productAuditPlanList',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'PROCESS & PRODUCT',
    span: 'AUDIT PLAN',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/common/productAuditPlanChecklistList',
    isLink: true,
    icon: <BsReverseListColumnsReverse size="5rem" color="#087f5b" />,
    p: 'PROCESS & PRODUCT',
    span: 'AUDIT PLAN STATUS',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="PRODUCT AUDIT" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
